var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEsp32Illustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "91px",
    height: "128px",
    viewBox: "0 0 91 128",
    style: {
      enableBackground: "new 0 0 91 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2D2D2D;}\r\n\t.st1{fill:#B3B2B3;}\r\n\t.st2{fill:#E2E2E2;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#E9E9E9;}\r\n\t.st4{fill:none;stroke:#000000;stroke-width:1.9376;stroke-miterlimit:10;}\r\n\t.st5{fill:#FCBD14;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FCBD14;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12531_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12530_",
    x: 0.2,
    y: 0,
    className: "st0",
    width: 90.6,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12529_",
    x: 6.6,
    y: 35.2,
    className: "st1",
    width: 77.4,
    height: 85.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12528_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.5,36.7V119H8l0-82.3H82.5 M84,35.2H6.6l0,85.3H84V35.2L84,35.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_12527_",
    className: "st3",
    cx: 14.5,
    cy: 114.1,
    r: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12630_",
    className: "st2",
    d: "M62.6,73.3c0,0-0.1-0.3-0.2-0.6c-0.5-1.2-1.4-2.9-2.1-4c-1.8-2.8-4.1-5.3-6.8-7.3 c-2.2-1.7-4.8-3-7.5-3.9c-0.3-0.1-0.5-0.2-0.5-0.2c0,0,0.1-0.3,0.1-0.5c0.2-0.6,0.1-0.5,0.9-0.6c2-0.2,4.4,0.2,6.5,0.9 c4.8,1.7,8.6,5.7,10,10.7c0.4,1.4,0.6,2.4,0.6,4c0,1,0,1.2,0,1.2c0,0-0.3,0.1-0.5,0.2L62.6,73.3L62.6,73.3z M58.1,82.6l-0.8,0 l0-0.4c0-0.7-0.2-1.7-0.3-2.4c-0.6-3.5-2.2-6.9-4.5-9.6c-3-3.5-7.1-5.8-11.7-6.6c-1.1-0.2-1.9-0.2-3.2-0.3l-0.9,0L36.6,62 c0-0.7-0.1-1.3,0-1.3c0-0.1,0.8-0.7,1.2-1.1c0.4-0.3,1.1-0.8,1.5-1.1l0.3-0.2l0.3,0c6.7,0.6,12.7,3.9,16.9,9.1 c2.5,3.1,4.3,6.9,5.1,10.9c0.1,0.4,0.1,0.7,0.1,0.8c0,0.3-1.1,2.1-1.8,3L60,82.5l-0.5,0C59.2,82.6,58.6,82.6,58.1,82.6z M37.3,85.8 c-1.1-0.2-2-0.9-2.3-2c-0.1-0.4-0.1-1-0.1-1.3c0.1-0.7,0.7-1.5,1.4-1.8c0.5-0.3,0.8-0.3,1.4-0.3c0.4,0,0.5,0,0.8,0.1 c0.8,0.3,1.5,0.9,1.8,1.7c0.3,0.7,0.2,1.4-0.1,2.1c-0.3,0.7-1,1.3-1.7,1.5C38.2,85.8,37.5,85.8,37.3,85.8z M46.1,88.3 c-0.7-0.1-1.5-0.2-2-0.3l-0.5-0.1l-0.8-0.6c-0.4-0.3-0.8-0.6-0.8-0.7c0,0,0-0.1,0.2-0.4c0.5-0.7,0.8-1.6,0.9-2.4 c0.1-0.5,0-1.4-0.1-1.8c-0.4-2-1.9-3.6-3.7-4.1c-0.6-0.2-1-0.2-1.7-0.3c-1.1,0-1.7-0.2-2.6-0.6c-1.2-0.5-2.1-1.4-2.7-2.5 c-0.5-0.8-0.7-1.7-0.7-2.4c0-0.8,0.1-2.2,0.3-2.7c0.7-1.9,2.3-3.3,4.4-3.8c0.5-0.1,1.9-0.2,2.7-0.1c4,0.3,7.5,1.9,10.5,4.5 c1.5,1.3,2.7,2.9,3.7,4.7c1,1.8,1.7,3.9,2,6.1c0.1,0.8,0.2,2.6,0.1,3.4c-0.1,1-0.3,2.5-0.4,2.6c-0.1,0.1-1.8,0.8-2.7,1.1l-0.4,0.1 l-1.1-0.4c-0.6-0.2-1.1-0.4-1.1-0.4c0,0,0-0.2,0.1-0.4c0.2-0.7,0.4-1.8,0.5-2.7c0-0.6,0-2.2-0.1-2.9c-0.3-2-1.1-3.8-2.2-5.4 c-2.2-3-5.6-4.9-9.3-5.2c-1.2-0.1-1.6,0-1.9,0.5c-0.1,0.2-0.1,0.2-0.1,0.5c0,0.4,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,1.2,0.3 c3.3,0.1,6.3,1.8,8.2,4.5c2.2,3.1,2.5,7.1,1,10.5c-0.3,0.8-0.4,0.9-0.6,0.9C46.6,88.4,46.4,88.3,46.1,88.3z M47.1,91.3 c-4.2-0.1-8.1-1.6-11.4-4.2c-0.7-0.6-1.9-1.7-2.5-2.4c-0.6-0.7-1.3-1.7-1.7-2.4c-1.5-2.3-2.4-4.9-2.7-7.7c-0.1-0.9-0.2-2.5-0.1-3.4 c0.2-4.3,1.9-8.3,4.7-11.5c0.2-0.2,0.3-0.3,0.4-0.3c0.1,0,1,0.9,1,0.9c0,0-0.2,0.2-0.4,0.5c-2,2.2-3.4,5.2-4,8.2 C30,70.4,30,71.4,30,73c0,1.2,0.1,1.9,0.3,3c0.7,3.4,2.5,6.7,5.1,9.1c3,2.8,6.7,4.5,10.9,4.9c0.8,0.1,2.4,0,3.2-0.1 c4.1-0.5,7.7-2.2,10.6-5.1l0.4-0.4l0.5,0.5l0.5,0.5l-0.2,0.2c-0.1,0.1-0.4,0.4-0.7,0.6c-3,2.8-6.6,4.5-10.7,5.1 C49.3,91.3,47.8,91.4,47.1,91.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12521_",
    className: "st2",
    points: "11.6,106.8 11.6,100.2 16.2,100.2 16.2,100.9 12.5,100.9 12.5,103 15.8,103  15.8,103.8 12.5,103.8 12.5,106 16.2,106 16.2,106.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12520_",
    className: "st2",
    d: "M16.6,104.6h0.8c0,0.5,0.2,0.9,0.5,1.2c0.3,0.3,0.7,0.5,1.2,0.5c0.5,0,0.9-0.1,1.2-0.3 c0.3-0.2,0.5-0.5,0.5-0.9c0-0.3-0.2-0.6-0.5-0.8c-0.3-0.1-0.6-0.3-1.1-0.4c-0.7-0.1-1.2-0.3-1.6-0.6c-0.5-0.4-0.7-0.8-0.7-1.4 c0-0.5,0.2-1,0.6-1.3c0.4-0.3,1-0.5,1.7-0.5c0.7,0,1.3,0.2,1.7,0.6c0.4,0.4,0.6,0.9,0.6,1.6h-0.8c-0.1-0.4-0.2-0.8-0.5-1 c-0.3-0.3-0.6-0.4-1-0.4c-0.5,0-0.8,0.1-1.1,0.3c-0.3,0.2-0.4,0.4-0.4,0.8c0,0.3,0.2,0.6,0.5,0.8c0.3,0.2,0.6,0.3,1,0.4 c0.7,0.1,1.3,0.3,1.7,0.6c0.5,0.3,0.8,0.7,0.8,1.3c0,0.6-0.2,1.1-0.7,1.5c-0.5,0.4-1.1,0.6-1.8,0.6c-0.8,0-1.4-0.2-1.8-0.7 C16.8,105.9,16.6,105.3,16.6,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12625_",
    className: "st2",
    d: "M23.2,103.3h1.9c0.4,0,0.7-0.1,0.9-0.3c0.2-0.2,0.3-0.5,0.3-0.9c0-0.4-0.1-0.7-0.3-0.9 c-0.2-0.2-0.5-0.3-0.9-0.3h-1.9V103.3z M22.4,106.8l0-6.7h2.7c0.6,0,1.1,0.2,1.5,0.5c0.4,0.3,0.6,0.8,0.6,1.4 c0,0.6-0.2,1.1-0.6,1.4c-0.4,0.4-0.9,0.5-1.5,0.5h-1.9v2.7L22.4,106.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12517_",
    x: 28,
    y: 104,
    className: "st2",
    width: 2.5,
    height: 0.7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12516_",
    className: "st2",
    points: "31.1,100.2 32,100.2 33.4,105.3 34.8,100.2 35.6,100.2 37,105.3 38.5,100.2  39.3,100.2 37.5,106.8 36.6,106.8 35.2,101.5 33.8,106.8 33,106.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12620_",
    className: "st2",
    d: "M40.8,103.3h2c0.4,0,0.7-0.1,1-0.3c0.2-0.2,0.4-0.5,0.4-0.9c0-0.4-0.1-0.7-0.4-0.9 c-0.2-0.2-0.6-0.3-1-0.3h-2V103.3z M39.9,106.8v-6.7h2.9c0.7,0,1.2,0.2,1.6,0.5c0.4,0.4,0.6,0.8,0.6,1.4c0,0.4-0.1,0.7-0.3,1 c-0.2,0.3-0.5,0.5-0.8,0.6c0.2,0.2,0.4,0.4,0.6,0.6c0.1,0.3,0.2,0.5,0.2,0.8l0,1.3c0,0.1,0,0.2,0.1,0.3l0,0.1h-0.8l0,0 c-0.1-0.2-0.1-0.3-0.1-0.4l0-1.3c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.2-0.6-0.3-0.9-0.3h-1.7v2.7L39.9,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12617_",
    className: "st2",
    d: "M46.3,103.5c0,0.8,0.2,1.5,0.6,1.9c0.4,0.5,0.9,0.7,1.6,0.7c0.7,0,1.2-0.2,1.6-0.7 c0.4-0.5,0.6-1.1,0.6-1.9c0-0.8-0.2-1.5-0.6-2c-0.4-0.5-0.9-0.7-1.6-0.7c-0.7,0-1.2,0.2-1.6,0.7C46.5,102,46.3,102.7,46.3,103.5z  M45.5,103.5c0-1.1,0.3-1.9,0.8-2.5c0.6-0.6,1.3-0.9,2.2-0.9s1.6,0.3,2.2,0.9c0.6,0.6,0.8,1.5,0.8,2.5c0,1-0.3,1.9-0.8,2.5 c-0.5,0.6-1.3,0.9-2.2,0.9c-0.9,0-1.6-0.3-2.2-0.9C45.8,105.4,45.5,104.5,45.5,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12614_",
    className: "st2",
    d: "M52.9,103.5c0,0.8,0.2,1.5,0.6,1.9c0.4,0.5,0.9,0.7,1.6,0.7c0.7,0,1.2-0.2,1.6-0.7 c0.4-0.5,0.6-1.1,0.6-1.9c0-0.8-0.2-1.5-0.6-2c-0.4-0.5-0.9-0.7-1.6-0.7c-0.7,0-1.2,0.2-1.6,0.7C53.1,102,52.9,102.7,52.9,103.5z  M52,103.5c0-1.1,0.3-1.9,0.8-2.5c0.6-0.6,1.3-0.9,2.2-0.9c0.9,0,1.6,0.3,2.2,0.9c0.6,0.6,0.8,1.5,0.8,2.5c0,1-0.3,1.9-0.8,2.5 c-0.5,0.6-1.3,0.9-2.2,0.9s-1.6-0.3-2.2-0.9C52.3,105.4,52,104.5,52,103.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_12509_",
    className: "st2",
    points: "58.9,106.8 58.9,100.2 59.9,100.2 62,105.4 64.1,100.2 65.1,100.2 65.1,106.8  64.3,106.8 64.3,101.8 62.3,106.8 61.7,106.8 59.7,101.8 59.7,106.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12508_",
    x: 66.3,
    y: 104,
    className: "st2",
    width: 2.5,
    height: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12507_",
    className: "st2",
    d: "M69.6,104.8h0.7c0,0.4,0.2,0.8,0.5,1c0.3,0.3,0.7,0.4,1.2,0.4c0.4,0,0.8-0.1,1.1-0.4 c0.3-0.3,0.5-0.6,0.5-1c0-0.4-0.2-0.6-0.5-0.9c-0.3-0.2-0.7-0.3-1.1-0.3h-0.6v-0.7H72c0.3,0,0.6-0.1,0.9-0.3 c0.3-0.2,0.4-0.5,0.4-0.8c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.5-0.3-0.9-0.3c-0.4,0-0.8,0.1-1,0.3c-0.3,0.2-0.5,0.5-0.5,0.9h-0.7 c0-0.6,0.2-1,0.6-1.4c0.4-0.4,0.9-0.6,1.5-0.6c0.6,0,1,0.2,1.5,0.5c0.4,0.3,0.6,0.8,0.6,1.3c0,0.3-0.1,0.6-0.2,0.8 c-0.1,0.3-0.3,0.5-0.6,0.6c0.3,0.1,0.6,0.3,0.8,0.6c0.2,0.3,0.3,0.6,0.3,1c0,0.6-0.2,1.1-0.7,1.5c-0.5,0.4-1,0.6-1.6,0.6 c-0.7,0-1.2-0.2-1.7-0.6C69.9,105.9,69.6,105.4,69.6,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12506_",
    className: "st2",
    d: "M75,106.8c0-0.6,0.2-1.2,0.7-1.8c0.4-0.5,0.9-0.9,1.6-1.3c0.5-0.3,0.8-0.5,1-0.7 c0.3-0.3,0.5-0.7,0.5-1c0-0.3-0.1-0.6-0.4-0.9c-0.3-0.2-0.6-0.3-1-0.3c-0.4,0-0.7,0.1-1,0.4c-0.3,0.3-0.4,0.6-0.4,1v0.4h-0.7v-0.4 c0-0.6,0.2-1.1,0.7-1.5c0.4-0.4,1-0.6,1.6-0.6c0.6,0,1.1,0.2,1.5,0.5c0.4,0.4,0.7,0.8,0.7,1.4c0,0.5-0.2,0.9-0.5,1.4 c-0.3,0.4-0.7,0.7-1.2,1l-0.2,0.1c-1,0.6-1.5,1.1-1.6,1.6h3.6v0.7L75,106.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_12177_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12505_",
    className: "st4",
    x1: 69.2,
    y1: 29.1,
    x2: 69.2,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12504_",
    className: "st4",
    x1: 80.4,
    y1: 29.1,
    x2: 80.4,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12503_",
    className: "st4",
    x1: 81.4,
    y1: 4.9,
    x2: 57.6,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12502_",
    className: "st4",
    x1: 57.6,
    y1: 4,
    x2: 57.6,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12501_",
    className: "st4",
    x1: 57.6,
    y1: 19,
    x2: 45.7,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12500_",
    className: "st4",
    x1: 45.7,
    y1: 20,
    x2: 45.7,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12499_",
    className: "st4",
    x1: 45.7,
    y1: 4.9,
    x2: 34.3,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12498_",
    className: "st4",
    x1: 34.3,
    y1: 4,
    x2: 34.3,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12497_",
    className: "st4",
    x1: 34.3,
    y1: 19,
    x2: 21.5,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12496_",
    className: "st4",
    x1: 21.5,
    y1: 20,
    x2: 21.5,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12495_",
    className: "st4",
    x1: 21.5,
    y1: 4.9,
    x2: 10.6,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_12494_",
    className: "st4",
    x1: 10.6,
    y1: 4,
    x2: 10.6,
    y2: 26.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12493_",
    x: 0.2,
    y: 35.2,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12492_",
    x: 0.2,
    y: 41.6,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12491_",
    x: 0.2,
    y: 47.9,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12490_",
    x: 0.2,
    y: 54.3,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12489_",
    x: 0.2,
    y: 60.7,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12488_",
    x: 0.2,
    y: 67.1,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12487_",
    x: 0.2,
    y: 73.5,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12486_",
    x: 0.2,
    y: 79.9,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12485_",
    x: 0.2,
    y: 86.3,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12484_",
    x: 0.2,
    y: 92.7,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12483_",
    x: 0.2,
    y: 99.1,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12482_",
    x: 0.2,
    y: 105.5,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12481_",
    x: 0.2,
    y: 111.8,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12480_",
    x: 0.2,
    y: 118.2,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12479_",
    x: 14.5,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12478_",
    x: 20.9,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12477_",
    x: 27.3,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12476_",
    x: 33.7,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12475_",
    x: 40,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12474_",
    x: 46.4,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12473_",
    x: 52.8,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12472_",
    x: 59.2,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12471_",
    x: 65.6,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12470_",
    x: 72,
    y: 124.2,
    className: "st5",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12469_",
    x: 87,
    y: 118.2,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12468_",
    x: 87,
    y: 111.8,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12467_",
    x: 87,
    y: 105.5,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12466_",
    x: 87,
    y: 99.1,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12465_",
    x: 87,
    y: 92.7,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12464_",
    x: 87,
    y: 86.3,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12463_",
    x: 87,
    y: 79.9,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12462_",
    x: 87,
    y: 73.5,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12461_",
    x: 87,
    y: 67.1,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12460_",
    x: 87,
    y: 60.7,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12459_",
    x: 87,
    y: 54.3,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12458_",
    x: 87,
    y: 47.9,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12457_",
    x: 87,
    y: 41.6,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12456_",
    x: 87,
    y: 35.2,
    className: "st5",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12455_",
    x: 87,
    y: 35.2,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12454_",
    x: 46.4,
    y: 124.2,
    className: "st6",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12453_",
    x: 72,
    y: 124.2,
    className: "st6",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12452_",
    x: 65.6,
    y: 124.2,
    className: "st6",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12451_",
    x: 87,
    y: 105.5,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12450_",
    x: 87,
    y: 111.8,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12449_",
    x: 52.8,
    y: 124.2,
    className: "st6",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12448_",
    x: 0.2,
    y: 54.3,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12447_",
    x: 0.2,
    y: 60.7,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12446_",
    x: 87,
    y: 60.7,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12445_",
    x: 87,
    y: 54.3,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12444_",
    x: 40,
    y: 124.2,
    className: "st6",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12443_",
    x: 87,
    y: 41.6,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12442_",
    x: 0.2,
    y: 67.1,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12441_",
    x: 0.2,
    y: 41.6,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12440_",
    x: 87,
    y: 47.9,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12439_",
    x: 87,
    y: 86.3,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12438_",
    x: 87,
    y: 79.9,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12437_",
    x: 87,
    y: 73.5,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12433_",
    x: 0.2,
    y: 47.9,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12431_",
    x: 87,
    y: 92.7,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12430_",
    x: 87,
    y: 118.2,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8853_",
    x: 0.2,
    y: 35.2,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8850_",
    x: 87,
    y: 67.1,
    className: "st6",
    width: 3.8,
    height: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8847_",
    x: 59.2,
    y: 124.2,
    className: "st6",
    width: 4.5,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_8831_",
    x: 87,
    y: 99.1,
    className: "st6",
    width: 3.8,
    height: 4.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEsp32Illustration);
export default __webpack_public_path__ + "static/media/icon-esp32-illustration.f9bf0709ca0bf4487fa48161e682c095.svg";
export { ForwardRef as ReactComponent };